"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SquareOutlined = exports.SquareFilled = void 0;
var react_1 = __importDefault(require("react"));
var SquareFilled = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "black" : _b, _c = _a.size, size = _c === void 0 ? 10 : _c, className = _a.className, _d = _a.style, style = _d === void 0 ? {} : _d, children = _a.children;
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: color, xmlns: "http://www.w3.org/2000/svg", className: className, style: style },
        react_1.default.createElement("rect", { width: "16", height: "16", rx: "1", fill: color }),
        children));
};
exports.SquareFilled = SquareFilled;
var SquareOutlined = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "black" : _b, _c = _a.size, size = _c === void 0 ? 10 : _c, className = _a.className, _d = _a.style, style = _d === void 0 ? {} : _d, children = _a.children;
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className, style: style },
        react_1.default.createElement("rect", { width: "16", height: "16", rx: "1", fill: "white", stroke: color, strokeWidth: "3" }),
        children));
};
exports.SquareOutlined = SquareOutlined;
